// extracted by mini-css-extract-plugin
module.exports = {"guideButton":"GuideShortcut_guideButton__3zNf4","disabled":"GuideShortcut_disabled__11FpS","title":"GuideShortcut_title__2zusy","icon":"GuideShortcut_icon__3OdDD"};